import { render, staticRenderFns } from "./EditReleaseNotesManagement.vue?vue&type=template&id=1d76e0ba&scoped=true&"
import script from "./EditReleaseNotesManagement.vue?vue&type=script&lang=js&"
export * from "./EditReleaseNotesManagement.vue?vue&type=script&lang=js&"
import style0 from "./EditReleaseNotesManagement.vue?vue&type=style&index=0&id=1d76e0ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d76e0ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/acarmichael/Desktop/DEV/BOSS40-FrontEnd/boss-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLabel } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VFlex,VForm,VIcon,VLabel,VLayout,VTextField})
